//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/require-default-prop */
/* eslint-disable max-len */
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import quasarProps from "./QuasarProps";

export default {
    name: "AQCard",
    components: {
        AQCheckbox,
        AQChip,
        AQAvatar,
        AQToggle,
        AQBadge,
        AQMenu
    },
    props: {
        ...quasarProps,
        checkboxProps: Object, // Object, props for the right side AQCheckbox
        avatarProps: Object, // Object, props for AQAvatar
        chipProps: Object, // Object, props for the left side AQChip
        chipPropsRight: Object, // Object, props for the right side AQChip
        inputProps: Object, // Object, props for
        toggleProps: Object, // Object, props for AQToggle
        badgeProps: Object, // Object, props for AQBadge
        menuProps: Object, // Object, props for AQMenu
        iconColor: String, // String left icon color
        rightIconColor: String, // String right icon color
        alignTop: Boolean, // Boolean, aligns items top -- !!! IF [sublabelLines] prop has a value greater than 2 alignTop is set to true
        /// //////////////// (request from design)!!!
        disableExpand: Boolean, // Boolean, disable expand/collapse functionality and hide right chevron
        fullFlex: Boolean, // Boolean, card is displayed flex instead of inline-flex (stretches full width)
        expandIconToggle: Boolean,
        rightIcon: String, // String right Icon to use.
        sublabel: String, // StringLabel to use as subtitle.
        sublabelLines: String, // String / NumberNumber of lines the sublabel can span to. Ellipsis are used when overflowing.
        cardOpen: { type: Boolean, default: undefined },
        disableHover: { type: Boolean, default: false },
        showSeparator: { type: Boolean, default: false },
        freeText: { type: Object, default: () => {} }
    },
    data() {
        return {
            toggleModel: false,
            checkboxModel: false,
            inputModel: "",
            popoverMenu: []
        };
    },
    computed: {
        computedClass() {
            let result = "aq-card";
            if (this.disableExpand) {
                result += " no-chevron";
            }
            if (this.fullFlex) {
                result += " full-flex";
            }
            if (this.checkboxModel) {
                result += " card-selected";
            }
            if (this.alignTop || this.sublabelLines > 1) {
                result += " align-top";
            }
            if (this.disableHover) {
                result += " disable-hover";
            }
            return result;
        },
        headerClassComp() {
            let result = this.headerClass ? `aq-card-header ${this.headerClass}` : "aq-card-header";
            if (this.disableExpand) {
                result += " targeted-no-chevron";
            }
            return result;
        },
        computedProps() {
            const result = { ...this.$props };
            delete result.checkboxProps;
            delete result.avatarProps;
            delete result.chipProps;
            delete result.chipPropsRight;
            delete result.inputProps;
            delete result.toggleProps;
            delete result.badgeProps;
            delete result.menuProps;
            delete result.cardOpen;
            delete result.disableHover;
            return result;
        }
    },
    watch: {},
    methods: {
        emitIsOpen(value) {
            this.$emit("card-open", value);
        },

        emitRightIconClick() {
            if (!this.disable) {
                this.$emit("rightIconClick");
            }
        },
        emitVModel(ev) {
            if (!this.disable) {
                this.$emit("input", ev);
            }
        },
        emitSelected(ev) {
            if (!this.disable) {
                this.$emit("selected", {
                    selected: ev,
                    item: { ...this.menuProps }
                });
            }
        },
        menuClick(event) {
            event.stopPropagation();
        }
    }
};
